import { useMemo } from "react";

import { StatusButton } from "modules/Dayplanner/components/StatusFilters/components";
import "modules/Dayplanner/components/StatusFilters/StatusFilters.scss";
import { DayplannerStatusOptions, matchesStatusFilter } from "modules/Dayplanner/utils";

import type { DAY_PLANNER_APPOINTMENT_STATUSES_FILTERS } from "models";
import type { DayplannerAppointment } from "modules/Dayplanner";

type StatusFilterProps = {
  appointments: DayplannerAppointment[];
  activeFilters: DAY_PLANNER_APPOINTMENT_STATUSES_FILTERS[];
  onSelect: (filter: DAY_PLANNER_APPOINTMENT_STATUSES_FILTERS) => void;
};

export const StatusFilters = ({ appointments, activeFilters, onSelect }: StatusFilterProps) => {
  const statuses = [...DayplannerStatusOptions.keys()];

  const filtersCount = useMemo(() => {
    const counts = statuses.reduce(
      (acc, status) => {
        acc[status] = 0;
        return acc;
      },
      {} as Record<DAY_PLANNER_APPOINTMENT_STATUSES_FILTERS, number>
    );

    appointments.forEach(appointment => {
      statuses.forEach(status => {
        if (matchesStatusFilter(appointment, status)) {
          counts[status] += 1;
        }
      });
    });

    return counts;
  }, [appointments, statuses]);

  return (
    <div className="DayplannerStatusFilters nav-bar-dp">
      {statuses.map(status => {
        const isDisabled = !activeFilters.some(e => e === status);

        return <StatusButton key={status} count={filtersCount[status]} filter={status} onClick={() => onSelect(status)} disabled={isDisabled} />;
      })}
    </div>
  );
};
